export const IngresoPromocionTradicionalHeader = ({promotion, idPromocion, estadoPromocion}) => {
	return (
		<div className='IngresoPromocionTradicionalHeader'>
			<div className='traditional-header-block traditional-header-recommendation'>
				<h1>Recomendación</h1>
				<p><b>{idPromocion}</b> | {promotion.recomendacion}</p>
			</div>
			<div className='traditional-header-block'>
				<h1>Fase</h1>
				<div className='traditional-header-pill'>{promotion.fase}</div>
			</div>
			<div className='traditional-header-block'>
				<h1>Estado</h1>
				<p>{estadoPromocion}</p>
			</div>
			<div className='traditional-header-block'>
				<h1>Creación</h1>
				<p>{promotion.fechaCreacion}</p>
			</div>
			<div className='traditional-header-block'>
				<h1>Actualización</h1>
				<p>{promotion.fechaActualizacion}</p>
			</div>
			<div className='traditional-header-block'>
				<h1>Margen</h1>
				<p><b>{promotion.margen}</b></p>
			</div>
			<div className='traditional-header-block'>
				<h1>N° SKU</h1>
				<p><b>{promotion.nroSku}</b></p>
			</div>
		</div>
	)
}
